module.exports = __webpack_public_path__ + "static/media/ECI88_Sportbook.17952940.png";